import FupUserModelBase from '../_generated/modelBases/fup-user-model-base';

export default class FupUserModel extends FupUserModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
